/* eslint-disable react/jsx-fragments */
import React from "react";
import PropTypes from "prop-types";
import { gatherClasses, isFunction, isString } from "../../lib/utils";
import "./dellHeaderbar.scss";

const DellHeaderbar = ({
  logo,
  portalName,
  portalLogo,
  fixed,
  consoleConfig
}) => {
  return (
    <div
      className={gatherClasses(
        null,
        "oui-dell-headerbar",
        fixed && "oui-fixed"
      )}
    >
      <div className="oui-item">
        {consoleConfig ? (
          <a
            href={consoleConfig && consoleConfig.href}
            onClick={consoleConfig && consoleConfig.onClick}
            target={consoleConfig && consoleConfig.target}
          >
            <img
              className="oui-dell-logo"
              src={logo}
              alt={isString(portalName) ? portalName : "Dell"}
            />
          </a>
        ) : (
          <img
            className="oui-dell-logo"
            src={logo}
            alt={isString(portalName) ? portalName : "Dell"}
          />
        )}
      </div>

      {portalName || portalLogo ? (
        <React.Fragment>
          <div className="oui-item">
            <div className="oui-separator" />
          </div>
          {portalName && (
            <div className="oui-item">
              {isFunction(portalName) ? portalName() : portalName}
            </div>
          )}
          {portalLogo && (
            <div className="oui-item">
              <img src={portalLogo} className="oui-msp-logo" alt="" />
            </div>
          )}
        </React.Fragment>
      ) : null}
    </div>
  );
};

DellHeaderbar.propTypes = {
  fixed: PropTypes.bool,
  logo: PropTypes.string,
  portalLogo: PropTypes.string,
  portalName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  consoleConfig: PropTypes.shape({
    href: PropTypes.string,
    onClick: PropTypes.func,
    target: PropTypes.string
  })
};

DellHeaderbar.defaultProps = {
  fixed: true
};

export default DellHeaderbar;
